import { render, staticRenderFns } from "./ExpenseBill.vue?vue&type=template&id=b144eb20&"
import script from "./ExpenseBill.vue?vue&type=script&lang=js&"
export * from "./ExpenseBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExpenseBill.vue"
export default component.exports